import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/salesCategories/new',
  title: 'title.new',
  endpoint: '/app/purchase_category',
  breadcrumbs: [],
}
